import React, { useState, useEffect } from 'react'

import { Drawer } from 'antd'
import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import SmartTable, { SmartTableDataTypes } from '../SmartTable'

const SchoolSpecialityUsers = props => {
  const t = useSelector(selectTranslate)

  const [users, setUsers] = useState([])

  useEffect(() => {
    if (props.entity) {
      const newUsers = props.entity.users

      for (const user of newUsers) {
        user.role = t(user.roles[0])
      }

      setUsers(newUsers)
    }
  }, [props.entity])

  const handleDrawerClose = () => {
    if (typeof props.onClose === 'function') {
      setUsers([])
      props.onClose()
    }
  }

  const columns = [
    { type: SmartTableDataTypes.ID, key: 'id' },
    {
      type: SmartTableDataTypes.STRING,
      name: t('Lastname'),
      key: 'lastname'
    },
    {
      type: SmartTableDataTypes.STRING,
      name: t('Firstname'),
      key: 'firstname'
    },
    {
      type: SmartTableDataTypes.STRING,
      name: t('Email'),
      key: 'email'
    },
    {
      type: SmartTableDataTypes.STRING,
      name: t('Role'),
      key: 'role'
    }
  ]

  return (
    <Drawer
      title={t('Speciality users')}
      width='50%'
      onClose={handleDrawerClose}
      visible={props.entity !== null}
    >
      <SmartTable
        columns={columns}
        data={users}
      />
    </Drawer>
  )
}

export default SchoolSpecialityUsers
